import { render, staticRenderFns } from "./dockRecords.vue?vue&type=template&id=102bbc94&scoped=true&"
import script from "./dockRecords.vue?vue&type=script&lang=js&"
export * from "./dockRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102bbc94",
  null
  
)

export default component.exports